import { combineReducers } from 'redux';
import chapters from 'tip/reducers/chapters';
import tip from 'tip/reducers/tip';
import history from 'tip/reducers/history';

export const tipReducer = combineReducers({
  tip,
  chapters,
  history,
});



// WEBPACK FOOTER //
// ./src/modules/tip/reducers/index.js